import React from 'react';
import { Phone, Mail, MapPin, Facebook, Instagram, Twitter } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0f0f0f] border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-8">
          {/* Company Info */}
          <div>
            <h3 className="text-xl font-bold mb-4">
              <span className="text-white">Premium Auto</span>
              <span className="text-[#ff6b35] ml-2">Repairs & Sales</span>
            </h3>
            <p className="text-gray-300 mb-6 leading-relaxed">
              North York's trusted automotive service center serving the entire GTA. Quality repairs, 
              honest service, and customer satisfaction guaranteed.
            </p>
            {/* Social Media */}
            <div className="mb-4">
              <p className="text-gray-400 text-sm mb-3">Follow us on social media</p>
              <div className="flex gap-4 mb-3">
                <a
                  href="https://www.facebook.com/premiumautorepairs"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-white/5 hover:bg-[#ff6b35]/20 border border-white/10 hover:border-[#ff6b35] rounded-lg flex items-center justify-center transition-all duration-200"
                >
                  <Facebook className="w-5 h-5 text-gray-400 hover:text-[#ff6b35]" />
                </a>
                <a
                  href="https://www.instagram.com/premiumautorepairs"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-white/5 hover:bg-[#ff6b35]/20 border border-white/10 hover:border-[#ff6b35] rounded-lg flex items-center justify-center transition-all duration-200"
                >
                  <Instagram className="w-5 h-5 text-gray-400 hover:text-[#ff6b35]" />
                </a>
                <a
                  href="https://twitter.com/premiumautorepairs"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-white/5 hover:bg-[#ff6b35]/20 border border-white/10 hover:border-[#ff6b35] rounded-lg flex items-center justify-center transition-all duration-200"
                >
                  <Twitter className="w-5 h-5 text-gray-400 hover:text-[#ff6b35]" />
                </a>
              </div>
              <a
                href="https://www.instagram.com/premiumautorepairs"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#ff6b35] hover:text-[#e55a28] font-medium transition-colors duration-200"
              >
                @premiumautorepairs
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => document.getElementById('home')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-[#ff6b35] transition-colors duration-200"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-[#ff6b35] transition-colors duration-200"
                >
                  Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-[#ff6b35] transition-colors duration-200"
                >
                  About Us
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-[#ff6b35] transition-colors duration-200"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-semibold mb-4">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-[#ff6b35] flex-shrink-0 mt-0.5" />
                <div>
                  <a
                    href="tel:416-747-6800"
                    className="text-gray-400 hover:text-[#ff6b35] transition-colors duration-200"
                  >
                    416-747-6800
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-[#ff6b35] flex-shrink-0 mt-0.5" />
                <div>
                  <a
                    href="mailto:7476800@gmail.com"
                    className="text-gray-400 hover:text-[#ff6b35] transition-colors duration-200 break-all"
                  >
                    7476800@gmail.com
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#ff6b35] flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-gray-400">
                    21 Millwick Dr<br />
                    North York, ON M9L 1Y4<br />
                    Canada
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/5">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm">
              © {currentYear} Premium Auto Repairs & Sales. All rights reserved.
            </p>
            <div className="flex gap-6 text-sm">
              <a href="#" className="text-gray-500 hover:text-[#ff6b35] transition-colors duration-200">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-500 hover:text-[#ff6b35] transition-colors duration-200">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
